import { Link } from 'react-router-dom';
import '../css/style.css';
import '../css/navbar.css'; // New CSS file for additional styles
import React, { Component } from 'react';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [
        { id: 1, name: "Live Video Monitoring & Security", path: "/services/remote-monitoring" },
        { id: 2, name: "Remote Concierge Services", path: "/services/remote-concierge" },
        { id: 3, name: "Remote Access Management", path: "/services/remote-access-management" },
        { id: 4, name: "Time Lapse Video Monitoring", path: "/services/time-lapse-monitoring" },
        { id: 5, name: "AI Powered Security", path: "/services/ai-powered-security" }
      ],
      industries: [
        { id: 1, name: "Construction", path: "/industries/construction" },
        { id: 2, name: "High-Rise Residential", path: "/industries/high-rise-residential" },
        { id: 3, name: "Trucking Facilities", path: "/industries/trucking-facilities" },
        { id: 4, name: "Automotive", path: "/industries/automotive" },
        { id: 5, name: "Commercial Businesses", path: "/industries/commercial-businesses" },
        { id: 6, name: "Storage Facilities", path: "/industries/storage-facilities" },
        { id: 7, name: "Outdoor Assets", path: "/industries/outdoor-assets" },
        { id: 8, name: "Property Management", path: "/industries/property-management" },
        { id: 9, name: "Solar Farms", path: "/industries/solar-farms" },
        { id: 10, name: "Cannabis Licensed Producers", path: "/industries/cannabis-licensed-producers" }
      ],
      scrolled: false,
      openDropdown: null,
      mobileMenuOpen: false
    };

    this.navbarRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleScroll = () => {
    const offset = window.scrollY;
    this.setState({ scrolled: offset > 50 });
  };

  handleClickOutside = (e) => {
    if (this.navbarRef.current && !this.navbarRef.current.contains(e.target)) {
      this.setState({ openDropdown: null, mobileMenuOpen: false });
    }
  };

  toggleDropdown = (menu) => {
    this.setState((prevState) => ({
      openDropdown: prevState.openDropdown === menu ? null : menu
    }));
  };

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      mobileMenuOpen: !prevState.mobileMenuOpen,
      openDropdown: null
    }));
  };

  closeMobileMenu = () => {
    this.setState({
      mobileMenuOpen: false,
      openDropdown: null
    });
  };

  render() {
    const { scrolled, openDropdown, services, industries, mobileMenuOpen } = this.state;
    const navbarClasses = `navbar custom-navbar fixed-top ${scrolled ? 'scrolled' : ''}`;

    return (
      <>
        <div id="leaves">
          <i className="leaf-icon leaf-1">🍁</i>
          <i className="leaf-icon leaf-2">🍁</i>
        </div>
        
        <nav className={navbarClasses} ref={this.navbarRef}>
          <div className="container menu-container d-flex align-items-center justify-content-between">
            <div className="cam">
              <img className="cam-image" alt="ai-cam" src="/images/cctv.gif" />
            </div>

            <Link className="navbar-brand orbitron" to="/">
              <img className="logo-image" alt="ai-logo" src="/images/SST1.svg" />
            </Link>

            <button 
              className={`navbar-toggler modern-toggler ${mobileMenuOpen ? 'active' : ''}`} 
              onClick={this.toggleMobileMenu}
            >
              <span className="toggler-line"></span>
              <span className="toggler-line"></span>
              <span className="toggler-line"></span>
            </button>

            <div className={`navbar-collapse modern-collapse ${mobileMenuOpen ? 'show' : ''}`}>
              <ul className="navbar-nav ms-auto modern-nav">
                <li className="nav-item">
                  <Link className="nav-link modern-nav-link" to="/" onClick={this.closeMobileMenu}>
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link modern-nav-link" to="/company" onClick={this.closeMobileMenu}>
                    Company
                  </Link>
                </li>

                {/* Services Dropdown */}
                <li className={`nav-item dropdown modern-dropdown ${openDropdown === 'services' ? 'show' : ''}`}>
                  <button
                    className="nav-link dropdown-toggle modern-dropdown-toggle industriesDropdown"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.toggleDropdown('services');
                    }}
                  >
                    Services
                    <span className={`dropdown-arrow ${openDropdown === 'services' ? 'active' : ''}`}>▼</span>
                  </button>
                  <ul className={`dropdown-menu modern-dropdown-menu ${openDropdown === 'services' ? 'show' : ''}`}>
                    {services.map(service => (
                      <li key={service.id} className="dropdown-item-wrapper">
                        <Link 
                          className="dropdown-item modern-dropdown-item" 
                          to={service.path} 
                          onClick={this.closeMobileMenu}
                        >
                          {service.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>

                {/* Industries Dropdown */}
                <li className={`nav-item dropdown modern-dropdown ${openDropdown === 'industries' ? 'show' : ''}`}>
                  <button 
                    className="nav-link dropdown-toggle modern-dropdown-toggle industriesDropdown" 
                    onClick={(e) => {
                      e.stopPropagation();
                      this.toggleDropdown('industries');
                    }}
                  >
                    Industries
                    <span className={`dropdown-arrow ${openDropdown === 'industries' ? 'active' : ''}`}>▼</span>
                  </button>
                  <ul className={`dropdown-menu modern-dropdown-menu ${openDropdown === 'industries' ? 'show' : ''}`}>
                    {industries.map(industry => (
                      <li key={industry.id} className="dropdown-item-wrapper">
                        <Link 
                          className="dropdown-item modern-dropdown-item" 
                          to={industry.path} 
                          onClick={this.closeMobileMenu}
                        >
                          {industry.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>

                <li className="nav-item">
                  <Link className="nav-link modern-nav-link" to="/about" onClick={this.closeMobileMenu}>
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link modern-nav-link" to="/contact" onClick={this.closeMobileMenu}>
                    Contact
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    className="nav-link free-quote" 
                    to="/contact" 
                    onClick={this.closeMobileMenu}
                  >
                    GET A FREE QUOTE
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Mobile Menu Overlay */}
          {mobileMenuOpen && <div className="mobile-overlay" onClick={this.closeMobileMenu}></div>}
        </nav>
      </>
    );
  }
}

export default Navbar;